<template>
  <GestionObjetivosVisita />
</template>
<script>
import GestionObjetivosVisita from "./components/GestionObjetivosVisita.vue";
export default {
  name: "Evento",
  components: { GestionObjetivosVisita }
};
</script>